import { BioCardGridProps } from '@ahc-digital/component-library';
import { getCheckbox, getDroplink } from '@/shared/param-utils';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { C56BiographyGridProps } from './C56BiographyGrid.types';

export function GetBiographyGridModel(props?: C56BiographyGridProps): BioCardGridProps {
  const { fields, params } = props || {};
  const { renderImage, renderText, renderLink } = useConditionalRendering();

  const mappedBios =
    fields?.Biographies?.map((bioItem) => {
      const { Image, Name, DisplayName, DetailedBioLink, Title } = bioItem.fields;

      return {
        displayName: renderText(DisplayName),
        image: renderImage(Image),
        name: renderText(Name),
        optionalLink: renderLink(DetailedBioLink),
        title: renderText(Title),
      };
    }) || [];

  return {
    bios: mappedBios,
    columnsDesktop: getDroplink(params?.GridNumberOfColumns, '4'),
    headline: renderText(fields?.Headline),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };
}
